import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@nook/ui"
import { Link } from "@tanstack/react-router"

/**
 * What a `PlanExpiredError` looks like (block 20): capture, Ask and regenerate
 * all render this rather than the raw `402`. The first thing it says after
 * "ended" is that nothing was lost (PRD §10.4) — the gate refuses new work and
 * takes nothing away.
 *
 * Links to the in-app billing section rather than the error's `upgradeUrl`: they are
 * the same page, and this one is a client-side navigation.
 */
export function UpgradePrompt({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Your trial has ended</DialogTitle>
          <DialogDescription>
            Your nooks are safe — everything you nooked is still here, browsable
            and searchable. Subscribe to Nook and Ask.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter showCloseButton>
          <Button asChild>
            <Link to="/settings" hash="billing" onClick={() => onOpenChange(false)}>
              Subscribe
            </Link>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
